module.exports = __webpack_public_path__ + "static/teamphoto2-ba34f6195be21d583dadba369a8e7820.jpg";